import Vue from 'vue'

export const state = () => ({
  forms: {},
})

export const mutations = {
  register(state, { id, label }) {
    Vue.set(state.forms, id, { label, dirty: false, fields: [] })
  },
  unregister(state, id) {
    Vue.delete(state.forms, id)
  },
  setDirty(state, { id, dirty, fields }) {
    if (state.forms[id]) {
      state.forms[id].dirty = dirty
      state.forms[id].fields = fields ?? []
    }
  },
}

export const getters = {
  anyDirty: (state) => Object.values(state.forms).some((f) => f.dirty),
  dirtyLabels: (state) =>
    Object.values(state.forms)
      .filter((f) => f.dirty)
      .map((f) => f.label),
  dirtyFormsWithFields: (state) =>
    Object.values(state.forms)
      .filter((f) => f.dirty)
      .map((f) => ({ label: f.label, fields: f.fields })),
}
